import { RudderAnalytics } from '@rudderstack/analytics-js';

export const rudderAnalytics = new RudderAnalytics();

